import {BaseCachedService} from './Core/BaseCachedService';

class EnvironmentalBenefitService extends BaseCachedService {
    get Url() { return super.Url + "/environmentalBenefits"; }
    get ModelName() { return "Environmental Benefit"; }
    get PrimaryKeyProperty() { return "environmentalBenefitId"; }
    
}

export const service = new EnvironmentalBenefitService();

